import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { stashHandoffCode } from './auth/sandboxHandoff';
import { isSignupHost } from './signup/host';
import { scrubBreadcrumb, scrubEvent } from './signup/sentryScrub';
import { stashCodeFromUrl, stashConnectReturnFromUrl } from './signup/storage';

export const SENTRY_DSN = 'https://a2fd0a96901d4eb4bfdb64acfabb42b9@o235272.ingest.sentry.io/5767443';

// Sentry for the whole dashboard (index.js). On the signup host the invite code is moved out of the
// URL fragment BEFORE Sentry.init: Sentry's default Breadcrumbs integration wraps history.replaceState
// and would record the pre-strip URL (`/#<code>`) as a navigation breadcrumb sent with any later event.
// The scrub hooks there cover every later URL (D1 review H1, signup/sentryScrub.ts). The outcome of "Connect with
// <booking system>" (`?<restech>=connected|error&reason=`) leaves the URL at the same moment. Tenant dashboards
// keep the SDK exactly as before. `overrides` and `hostname` are test seams.
export function initSentry(overrides = {}, hostname = window.location.hostname) {
    const signup = isSignupHost(hostname);
    if (signup) {
        stashCodeFromUrl();
        stashConnectReturnFromUrl();
    }
    // A sandbox sign-in from production (DSEC D3): its one-time code leaves the fragment, into memory only.
    stashHandoffCode();
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing()],
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'dev',

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: +process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE || 0.01,
        ...(signup ? { beforeBreadcrumb: scrubBreadcrumb, beforeSend: scrubEvent } : {}),
        ...overrides,
    });
    if (signup) {
        // beforeSend skips transactions; an event processor sees every event (the request URL of a
        // performance transaction too).
        Sentry.addGlobalEventProcessor((event) => scrubEvent(event));
    }
}
